import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function UndoStopIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 14"
      style={{ width: `22px`, height: `24px`, color: RoutalPalette.primary40, ...props.style }}
    >
      <g>
        <path d="M14.18,4.83c-.99-.99-2.31-1.54-3.71-1.54H3.7l1.68-1.68c.12-.12.12-.32,0-.44l-.86-.87c-.06-.06-.14-.06-.22-.09-.08,0-.16.03-.22.09L.38,4c-.06.06-.09.14-.09.22s.03.16.09.22l3.7,3.7c.06.06.14.09.22.09.08.02.16-.03.22-.09l.86-.87c.12-.12.12-.32,0-.44l-1.68-1.68h6.76c1.87,0,3.39,1.52,3.39,3.39,0,1.87-1.52,3.39-3.39,3.39h-4.94c-.17,0-.31.14-.31.31v1.23c0,.17.14.31.31.31h4.94c2.89,0,5.25-2.35,5.25-5.25,0-1.4-.55-2.72-1.54-3.71Z" />
      </g>
    </SvgIcon>
  );
}
